import { compare, Operation } from 'fast-json-patch';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '@ngrx/store';
import { ErrorModel } from '../../app/models/error.model';
import { ApplicationConfiguration } from './category-applications/category-applications.state';
import { VppApplicationConfiguration } from './category-vpp-applications/category-vpp-applications.state';
import { catchErrorWithToast } from './shared/toast-utils';
import { CategoryType, IToastie } from './shared/types';

export function compareApplications(action: {
  id: string;
  categoryType: CategoryType;
  previousApplicationsLinkedToCategory: ApplicationConfiguration[];
  updatedApplicationsLinkedToCategory: ApplicationConfiguration[];
}): Operation[] {
  return compare(
    action.previousApplicationsLinkedToCategory.map((x) => ({
      bundleIdentifier: x.bundleIdentifier,
      version: x.version,
      applyFrom: x.applyFrom,
      applyTill: x.applyTill,
    })),
    action.updatedApplicationsLinkedToCategory.map((x) => ({
      bundleIdentifier: x.bundleIdentifier,
      version: x.version,
      applyFrom: x.applyFrom,
      applyTill: x.applyTill,
    }))
  );
}

export function compareVppApplications(action: {
  categoryId: string;
  categoryType: CategoryType;
  previousApplicationsLinkedToCategory: VppApplicationConfiguration[];
  updatedApplicationsLinkedToCategory: VppApplicationConfiguration[];
}): Operation[] {
  return compare(
    action.previousApplicationsLinkedToCategory.map((x) => ({
      adamIdStr: x.adamIdStr,
      applyFrom: x.applyFrom,
      version: x.version,
    })),
    action.updatedApplicationsLinkedToCategory.map((x) => ({
      adamIdStr: x.adamIdStr,
      applyFrom: x.applyFrom,
      version: x.version,
    }))
  );
}

export function safeMap<T, A, E extends Action>(
  result: Observable<T>,
  createAction: (t: T) => A | A[],
  createError: (error: ErrorModel) => E,
  toastMessage?: string
): Observable<A | (E & { toast: IToastie })> {
  return result.pipe(
    mergeMap((x) => {
      const action = createAction(x);
      return Array.isArray(action) ? action : [action];
    }),
    catchErrorWithToast((error) => createError(error), toastMessage)
  );
}
